const EVALUACIONES_TRIANUALES = [
  {
    id: 'tr-001',
    nombre: 'AGUIRRE, GERMAN OSCAR',
    legajo: 'TRP9000001859',
    examen: 'TRIANUAL',
  },
  {
    id: 'tr-002',
    nombre: 'NEUBERGER, ALEJANDRO',
    legajo: 'GES0022412444',
    examen: 'TRIANUAL',
  },
  {
    id: 'tr-003',
    nombre: 'PEREZ, MARIA LAURA',
    legajo: 'TRP8000003241',
    examen: 'TRIANUAL',
  },
  {
    id: 'tr-004',
    nombre: 'GONZALEZ, JUAN PABLO',
    legajo: 'TRP8000009987',
    examen: 'TRIANUAL',
  },
];

const PREGUNTAS_TEMPLATE = [
  {
    id: '1',
    preguntaId: 1,
    pregunta: 'UTILIZA CORRECTAMENTE EL EPP OBLIGATORIO DURANTE TODA LA TAREA.',
    respuesta: '',
    observacion: '',
    requiere_evidencia: true,
    evidencia: '',
  },
  {
    id: '2',
    preguntaId: 2,
    pregunta:
      'VERIFICA EL ESTADO DEL MUELLE Y REPORTA CONDICIONES INSEGURAS ANTES DE OPERAR.',
    respuesta: '',
    observacion: '',
    requiere_evidencia: true,
    evidencia: '',
  },
  {
    id: '3',
    preguntaId: 3,
    pregunta: 'MANTIENE COMUNICACION RADIAL CLARA CON EL EQUIPO DURANTE MANIOBRAS.',
    respuesta: '',
    observacion: '',
    requiere_evidencia: true,
    evidencia: '',
  },
  {
    id: '4',
    preguntaId: 4,
    pregunta:
      'APLICA EL PROCEDIMIENTO DE BLOQUEO Y SENALIZACION DEL EQUIPO CUANDO CORRESPONDE.',
    respuesta: '',
    observacion: '',
    requiere_evidencia: true,
    evidencia: '',
  },
  {
    id: '5',
    preguntaId: 5,
    pregunta:
      'CONTROLA LA ESTABILIDAD Y DISTRIBUCION SEGURA DE LA CARGA DURANTE LA OPERACION.',
    respuesta: '',
    observacion: '',
    requiere_evidencia: true,
    evidencia: '',
  },
  {
    id: '6',
    preguntaId: 9,
    pregunta: 'COMPLETA CORRECTAMENTE LOS REGISTROS OPERATIVOS Y PARTES DE TURNO.',
    respuesta: '',
    observacion: '',
    requiere_evidencia: true,
    evidencia: '',
  },
  {
    id: '7',
    preguntaId: 10,
    pregunta:
      'INTERRUMPE LA TAREA ANTE CONDICIONES CLIMATICAS O NAUTICAS NO SEGURAS.',
    respuesta: '',
    observacion: '',
    requiere_evidencia: true,
    evidencia: '',
  },
];

export const TOTAL_PREGUNTAS_TRIANUAL = PREGUNTAS_TEMPLATE.length;

export function getEvaluacionesTrianuales() {
  return EVALUACIONES_TRIANUALES;
}

export function buildEvaluacionTrianual(evaluado) {
  return {
    evaluadoId: evaluado.id,
    id_entidad: evaluado.id_entidad,
    nombreEvaluado: evaluado.nombre,
    legajoEvaluado: evaluado.legajo,
    examen: evaluado.examen,
    firma: '',
    preguntas: PREGUNTAS_TEMPLATE.map((item) => ({
      ...item,
      evidenciaPreview: '',
    })),
  };
}

export function getFirstQuestionId() {
  return PREGUNTAS_TEMPLATE[0].id;
}
